import type { StoreContextState } from "./StoreContextWrapper";

export interface LoadingActions {
    startLoading(requestId: string): void;
    stopLoading(requestId: string): void;
}

const Actions = () => ({
    setApiBasePath(state: StoreContextState, basePath: string) {
        return { apiBasePath: basePath };
    },

    startLoading(state: StoreContextState, requestId: string) {
        return {
            isLoading: true,
            error: "",
            pendingRequests: [
                ...new Set([...state.pendingRequests, requestId]),
            ],
        };
    },

    stopLoading(state: StoreContextState, requestId: string) {
        const pendingRequests = state.pendingRequests.filter(
            (id) => id !== requestId,
        );
        return { isLoading: pendingRequests.length > 0, pendingRequests };
    },

    setError(state: StoreContextState, newError: unknown) {
        return { error: newError, isLoading: state.pendingRequests.length > 0 };
    },
});

export default Actions;
